<script>
    import dayjs from "dayjs";
    let year = dayjs().format('YYYY');
</script>

<div class="p-1">{year} &copy; Guglielmo <i>v1.0.0</i></div>
